import { observer } from 'mobx-react';
import React from 'react';

const ProfilePage: React.FC = () => {
    return (
        <div className="content">
            Профиль
        </div>
    );
}

export default observer(ProfilePage);